import { useEffect } from 'react';
import eventBus from '@sas/nova-core/eventBus';

// Used as EventData for the eventBus
var SettingsEventTypes = /*#__PURE__*/function (SettingsEventTypes) {
  SettingsEventTypes["Change"] = "SettingsEvent.Change";
  return SettingsEventTypes;
}(SettingsEventTypes || {});
export function useSubscribeForSettingsChange(changeListener) {
  useEffect(() => {
    subscribeSettingsChange(changeListener);
    return () => {
      unSubscribeSettingsChange(changeListener);
    };
  }, [changeListener]);
}
export function subscribeSettingsChange(listener) {
  eventBus.subscribe(SettingsEventTypes.Change, listener);
}
export function unSubscribeSettingsChange(listener) {
  eventBus.unsubscribe(SettingsEventTypes.Change, listener);
}
export function fireSettingsChange(eventInfo, appId) {
  eventBus.publish(SettingsEventTypes.Change, {
    data: {
      data: eventInfo,
      appId
    }
  });
}
//# sourceMappingURL=SettingsChangeEvent.js.map